import { Diamond } from "lucide-react";

export const CollectibleCard = ({ item, children, prefix = "digital-collectible" }) => {
  const remaining = Math.max(0, item.total_supply - item.sold_count - (item.reserved_count || 0));
  return <article data-testid={`${prefix}-${item.collectible_id}`} className="min-w-0 overflow-hidden rounded-lg border border-[#1A2030] bg-[#0A0E18]">
    <div className="aspect-square bg-[#050810] flex items-center justify-center p-3">
      {item.preview_url ? <img data-testid={`${prefix}-preview-${item.collectible_id}`} src={`${process.env.REACT_APP_BACKEND_URL}${item.preview_url}`} alt={item.title} className="w-full h-full object-contain" /> : <Diamond className="w-10 h-10 text-[#8A92A0]" />}
    </div>
    <div className="p-4 space-y-3 min-w-0">
      <p className="text-xs text-[#8A92A0]">Digital collectible · No shipping</p>
      <h3 data-testid={`${prefix}-title-${item.collectible_id}`} className="font-semibold text-white break-words">{item.title}</h3>
      {item.description && <p className="text-sm text-[#8A92A0] line-clamp-2 break-words">{item.description}</p>}
      <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
        <span data-testid={`${prefix}-price-${item.collectible_id}`} className="font-semibold text-[#FF66BB]">{Number(item.price).toFixed(2)} Tokens</span>
        <span data-testid={`${prefix}-remaining-${item.collectible_id}`} className="text-[#8A92A0]">{remaining} of {item.total_supply} left</span>
      </div>
      <p data-testid={`${prefix}-policy-${item.collectible_id}`} className="text-xs text-[#8A92A0]">Collect multiple editions · One download per purchase</p>
      {children}
    </div>
  </article>;
};